import { render, staticRenderFns } from "./CommonSummary.vue?vue&type=template&id=47daea8a"
import script from "./CommonSummary.vue?vue&type=script&lang=js"
export * from "./CommonSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47daea8a')) {
      api.createRecord('47daea8a', component.options)
    } else {
      api.reload('47daea8a', component.options)
    }
    module.hot.accept("./CommonSummary.vue?vue&type=template&id=47daea8a", function () {
      api.rerender('47daea8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/PanelGroup/CommonSummary.vue"
export default component.exports